export default {"src":"/_next/static/media/google-store-logo.07cf0db4.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};